import { useState } from 'react';
import { getExcelUrl, hasExcelFile } from './excel-mapping';

export default function Obras() {
    const obrasPorAno = {
        '2022': [
            {
                descricao: 'Contratação de empresa especializada em serviços de engenharia para executar os serviços de reparos do reservatório elevado, da caixa da escada e da cobertura, todos no Anexo 02 da ALEPE, conforme descritos no Termo de Referência',
                numeroContrato: '009/2022 (Pregão Eletrônico nº 018/2021)',
                empresa: 'A. C. Queiroz Construções Eireli',
                inicio: '25/07/2022',
                prazoEstimado: '3 meses',
                conclusao: '25/10/22',
                situacao: 'Concluída',
                percentual: '42,97%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2022-1-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2022-1-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2022-1-acompanhamento-2.pdf']
            },
            {
                descricao: 'Contratação de empresa especializada em serviços de pintura de piso, pilares e teto do estacionamento (semi-enterrado) do Edifício Miguel Arraes da ALEPE, conforme descritos no Termo de Referência',
                numeroContrato: '056/2022 (Pregão Eletrônico nº 024/2022)',
                empresa: 'JACKSON MENDES DE SOUZA GASPLAN SOLUÇÕES RENOVÁVEIS EIRELI - EPP',
                inicio: '16/11/2022',
                prazoEstimado: '12 meses',
                conclusao: '11/11/2023',
                situacao: 'Em andamento',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2022-2-original.pdf'],
                planilhaAcompanhamento: []
            },
            {
                descricao: 'Contratação de empresa especializada de engenharia para execução da obra de reforma com acréscimo de área no imóvel da antiga ESCOLA SÃO FRANCISCO DE ASSIS para implantação da SUPERINTENDÊNCIA DE SAÚDE E MEDICINA OCUPACIONAL - SSMO DA ALEPE',
                numeroContrato: '014/2022 (Concorrência nº 003/2021)',
                empresa: 'EXECUTAR ENGENHARIA EIRELI',
                inicio: '06/04/2022',
                prazoEstimado: '24 meses',
                conclusao: '3/11/2022',
                situacao: 'Contrato não assinado',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2022-3-original.xlsx'],
                planilhaAcompanhamento: []
            },
            {
                descricao: 'Contratação de empresa especializada em serviços de engenharia para reforma da impermeabilização e do sistema de drenagem da coberta do Edifício Miguel Arraes',
                numeroContrato: '059/2022 (Pregão Eletrônico nº 025/2022)',
                empresa: 'JACKSON MENDES DE SOUZA GASPLAN SOLUÇÕES RENOVÁVEIS EIRELI - EPP',
                inicio: '22/12/2022',
                prazoEstimado: '12 meses',
                conclusao: '17/12/23',
                situacao: 'Em andamento',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2022-4-original.pdf'],
                planilhaAcompanhamento: []
            }
        ],
        '2023': [
            {
                descricao: 'Contratação de empresa especializada em serviços de engenharia para executar os serviços de reparos do reservatório elevado, da caixa da escada e da cobertura, todos no Anexo 02 da ALEPE, conforme descritos no Termo de Referência',
                numeroContrato: '009/2022 (Pregão Eletrônico nº 018/2021)',
                empresa: 'A. C. Queiroz Construções Eireli',
                inicio: '25/07/2022',
                prazoEstimado: '3 meses',
                conclusao: '25/10/22',
                situacao: 'Concluída',
                percentual: '42,97%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2022-1-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2022-1-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2022-1-acompanhamento-2.pdf']
            },
            {
                descricao: 'Contratação de empresa especializada em serviços de pintura de piso, pilares e teto do estacionamento (semi-enterrado) do Edifício Miguel Arraes da ALEPE',
                numeroContrato: '056/2022 (Pregão Eletrônico nº 024/2022)',
                empresa: 'JACKSON MENDES DE SOUZA GASPLAN SOLUÇÕES RENOVÁVEIS EIRELI - EPP',
                inicio: '11/16/2022',
                prazoEstimado: '12 meses',
                conclusao: '11/11/2023',
                situacao: 'Concluída',
                percentual: '100%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2023-1-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2023-1-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2023-1-acompanhamento-2.pdf']
            },
            {
                descricao: 'Contratação de empresa especializada em serviços de engenharia para reforma da impermeabilização e do sistema de drenagem da coberta do Edifício Miguel Arraes',
                numeroContrato: '059/2022 (Pregão Eletrônico nº 025/2022)',
                empresa: 'JACKSON MENDES DE SOUZA GASPLAN SOLUÇÕES RENOVÁVEIS EIRELI - EPP',
                inicio: '12/22/2022',
                prazoEstimado: '12 meses',
                conclusao: '22/12/2022',
                situacao: 'Concluída',
                percentual: '90,59%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: [],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento-2.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento-3.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento-4.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento-5.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2023-2-acompanhamento-6.pdf'
                ]
            },
            {
                descricao: 'Contratação de empresa especializada para execução de demolições dos edifícios do Anexo III e antigo Hotel União',
                numeroContrato: '038/2023 (Pregão Eletrônico nº 010/2023)',
                empresa: 'DIAS COMÉRCIO E SERVIÇOS DE EDIFICAÇÕES LTDA',
                inicio: '19/09/2023',
                prazoEstimado: '12 meses',
                conclusao: '13/09/2024',
                situacao: 'Obra não concluída, e a empresa não teve o interesse de renovar o prazo contratual',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2023-3-original.pdf'],
                planilhaAcompanhamento: []
            },
            {
                descricao: 'Contratação de empresa para confecção, montagem e instalação de corrimãos e bicicletário',
                numeroContrato: '060/2022 (Pregão Eletrônico nº 027/2022)',
                empresa: 'JACKSON MENDES DE SOUZA GASPLAN SOLUÇÕES RENOVÁVEIS EIRELI - EPP',
                inicio: '21/12/2022',
                prazoEstimado: '6 meses',
                conclusao: '21/12/22',
                situacao: 'Concluída',
                percentual: '100%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2023-4-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2023-4-acompanhamento.pdf']
            }
        ],
        '2024': [
            {
                descricao: 'CONTRATAÇÃO DE EMPRESA ESPECIALIZADA DE ENGENHARIA PARA EXECUÇÃO DE REFORMA E RESTAURAÇÃO DO PALÁCIO JOAQUIM NABUCO DA ALEPE',
                numeroContrato: '073/2024 (Concorrência Pública nº 004/2023.)',
                empresa: 'CONSÓRCIO CINZEL/KONEX',
                inicio: '11/26/2024',
                prazoEstimado: '36 meses',
                conclusao: '11/11/2027',
                situacao: 'Em Andamento',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-1-original.xlsx'],
                planilhaAcompanhamento: []
            },
            {
                descricao: 'Contratação de empresa de engenharia para Reforma do Foyer e área de exposição do Edifício Miguel Arraes',
                numeroContrato: '057/2024 (Pregão Eletrônico nº020/2024)',
                empresa: 'CONSTRUTORA MENDES SOUZA LTDA',
                inicio: '11/07/2024',
                prazoEstimado: '12 meses',
                conclusao: '02/11/2025',
                situacao: 'Em Andamento',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-2-original.pdf'],
                planilhaAcompanhamento: []
            },
            {
                descricao: 'Contratação de empresa especializada para execução de demolições dos edifícios do Anexo III e antigo Hotel União',
                numeroContrato: '038/2023 (Pregão Eletrônico nº 010/2023)',
                empresa: 'DIAS COMÉRCIO E SERVIÇOS DE EDIFICAÇÕES LTDA',
                inicio: '01/03/1900',
                prazoEstimado: '12 meses',
                conclusao: '13/09/2024',
                situacao: 'Contrato finalizado. Obra não concluída, e a empresa não teve o interesse de renovar o prazo contratual.',
                percentual: '7,33%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-3-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-3-acompanhamento.pdf']
            },
            {
                descricao: 'Contratação de empresa de engenharia para reforma da sala da Presidência',
                numeroContrato: '034/2024 (Pregão Eletrônico nº 011/2024)',
                empresa: 'A. G. F. SILVA ENGENHARIA',
                inicio: '29/07/2024',
                prazoEstimado: '360 dias',
                conclusao: '24/07/2025',
                situacao: 'Concluída',
                percentual: '83,84%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-4-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-4-acompanhamento.pdf']
            },
            {
                descricao: 'Contratação de empresa para serviço de pintura dos prédios da ALEPE',
                numeroContrato: '059/2024 (Pregão Eletrônico nº 008/2024)',
                empresa: 'ÁVIGA ENGENHARIA LTDA',
                inicio: '09/12/2024',
                prazoEstimado: '365 dias',
                conclusao: '04/12/2025',
                situacao: 'Em Andamento',
                percentual: '0,00%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-5-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-5-acompanhamento.pdf']
            },
            {
                descricao: 'Serviços de manutenção com materiais e sob demanda da ALEPE',
                numeroContrato: '074/2024 (Dispensa de Licitação nº 003/2024)',
                empresa: 'JI CONTRUTORA E SERVIÇOS LTDA',
                inicio: '26/11/2024',
                prazoEstimado: '12 meses',
                conclusao: '21/11/2025',
                situacao: 'Em Andamento',
                percentual: '49,83%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-6-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-6-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-6-acompanhamento-2.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-6-acompanhamento-3.pdf']
            },
            {
                descricao: 'Serviço de demolição e destinação final da antiga escola São Francisco de Assis',
                numeroContrato: '02/2024 (Pregão Eletrônico nº 022/2023)',
                empresa: 'MAGALHÃES DEMOLIÇÃO LTDA',
                inicio: '01/02/2024',
                prazoEstimado: '1 ano',
                conclusao: '31/01/2025',
                situacao: 'Finalizado',
                percentual: '93,02%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-7-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-7-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-7-acompanhamento-2.pdf']
            },
            {
                descricao: 'Reforma da sala de estar dos motoristas',
                numeroContrato: '042/2024 (Pregão Eletrônico nº 009/2024)',
                empresa: 'MJM ENGENHARIA E EQUIPAMENTOS LTDA',
                inicio: '02/09/2024',
                prazoEstimado: '360 dias',
                conclusao: '28/08/2025',
                situacao: 'Em Andamento',
                percentual: '89,41%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-8-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-8-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-8-acompanhamento-2.pdf']
            },
            {
                descricao: 'Reforma da sala de estar dos deputados',
                numeroContrato: '043/2024 (Pregão Eletrônico nº 012/2024,)',
                empresa: 'SS – OBRAS DE TERRAPLENAGEM E LOCAÇÕES DE MÁQUINAS',
                inicio: '16/08/2024',
                prazoEstimado: '360 dias',
                conclusao: '11/08/2025',
                situacao: 'Finalizado',
                percentual: '99,92%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-9-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-9-acompanhamento.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-9-acompanhamento-2.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-9-acompanhamento-3.pdf', 'https://www.alepe.pe.gov.br/downloads/obras/2024-9-acompanhamento-4.pdf']
            },
            {
                descricao: 'Reforma e recuperação da cúpula sobre o Plenário dos deputados',
                numeroContrato: '033/2024 (Dispensa de Licitação nº 006/2024)',
                empresa: 'VIEWS PROJETOS E CONSTRUÇÕES LTDA',
                inicio: '03/07/2024',
                prazoEstimado: '6 meses',
                conclusao: '30/12/2024',
                situacao: 'Finalizado',
                percentual: '100%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2024-10-original.pdf'],
                planilhaAcompanhamento: ['https://www.alepe.pe.gov.br/downloads/obras/2024-10-acompanhamento.pdf']
            }
        ],
        '2025': [
            {
                descricao: 'CONTRATAÇÃO DE EMPRESA ESPECIALIZADA DE ENGENHARIA PARA EXECUÇÃO DE REFORMA E RESTAURAÇÃO DO PALÁCIO JOAQUIM NABUCO DA ALEPE, conforme especificações técnicas e condições constantes do Projeto Executivo, do Cronograma Físico-Financeiro com Desembolso e do Orçamento Estimado em Planilha de Quantitativos e Preços Unitários, que integram a Concorrência Pública nº 004/2023.',
                numeroContrato: '073/2024 (Concorrência Pública nº 004/2023)',
                empresa: 'CONSÓRCIO CINZEL/KONEX',
                inicio: '26/11/2024',
                prazoEstimado: '36 meses',
                conclusao: '',
                situacao: 'Em andamento',
                percentual: '94.16%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-1-original.xlsx'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-2.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-3.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-4.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-5.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-6.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-7.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-8.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-9.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-10.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-11.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-12.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-13.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-14.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-15.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-16.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-17.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-18.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-1-acompanhamento-19.pdf'
                ]
            },
            {
                descricao: 'Contratação de empresa de engenharia para Reforma do Foyer e área de exposição do Edifício Miguel Arraes',
                numeroContrato: '057/2024 (Pregão Eletrônico nº 020/2024)',
                empresa: 'CONSTRUTORA MENDES SOUZA LTDA',
                inicio: '07/11/2024',
                prazoEstimado: '12 meses',
                conclusao: '',
                situacao: 'Concluído',
                percentual: '77,75%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-2-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-2-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-2-acompanhamento-2.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-2-acompanhamento-3.pdf'
                ]
            },
            {
                descricao: 'Contratação de empresa de engenharia para execução de reforma da sala da Presidência, localizada na ALEPE (ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO).',
                numeroContrato: '034/2024 (Pregão Eletrônico nº 011/2024)',
                empresa: 'A. G. F. SILVA ENGENHARIA',
                inicio: '29/07/2024',
                prazoEstimado: '360 dias',
                conclusao: '',
                situacao: 'Em andamento',
                percentual: '100%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-3-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-3-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-3-acompanhamento-2.pdf'
                ]
            },
            {
                descricao: 'Contratação de empresa de engenharia para execução do serviço de pintura dos prédios da Assembleia Legislativa de Pernambuco, pelo período de 365 (trezentos e sessenta e cinco) dias.',
                numeroContrato: '059/2024 (Pregão Eletrônico Nº 008/2024)',
                empresa: 'ÁVIGA ENGENHARIA LTDA',
                inicio: '09/12/2024',
                prazoEstimado: '365 dias',
                conclusao: '',
                situacao: 'Em andamento',
                percentual: '23,30%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-4-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-4-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-4-acompanhamento-2.pdf'
                ]
            },
            {
                descricao: 'Contratação de empresa especializada na prestação de serviços de manutenção, com fornecimento de materiais e sob demanda, a fim de reparar e manter o estado de conservação das instalações físicas da Assembleia Legislativa do Estado de Pernambuco (ALEPE), mediante o oferecimento do maior percentual de desconto sobre a tabela SINAPI onerada fevereiro de 2023, conforme descritos no Termo de Referência e conforme solicitação do Departamento de Serviços Gerais e Manutenção Predial.',
                numeroContrato: '074/2024 (Dispensa de Licitação nº 003/2024)',
                empresa: 'JI CONTRUTORA E SERVIÇOS LTDA',
                inicio: '26/11/2024',
                prazoEstimado: '12 meses',
                conclusao: '',
                situacao: 'Em andamento',
                percentual: '62.48%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-5-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-2.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-3.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-4.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-5.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-6.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-7.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-8.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-9.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-10.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-11.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-12.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-13.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-14.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-15.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-16.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-17.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-18.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-19.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-5-acompanhamento-21.pdf'
                ]
            },
            {
                descricao: 'CONTRATAÇÃO DE EMPRESA DE ENGENHARIA PARA EXECUÇÃO DE REFORMA DA SALA DE ESTAR DOS MOTORISTAS, LOCALIZADA NO EDIFÍCIO MIGUEL ARRAES DA ALEPE (ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO).',
                numeroContrato: '042/2024 (Pregão Eletrônico nº 009/2024)',
                empresa: 'MJM ENGENHARIA E EQUIPAMENTOS LTDA',
                inicio: '02/09/2024',
                prazoEstimado: '360 dias',
                conclusao: '16/01/2025',
                situacao: 'Concluído',
                percentual: '89,41%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-6-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-6-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-6-acompanhamento-2.pdf'
                ]
            },
            {
                descricao: 'CONTRATAÇÃO DA DE EMPRESA DE ENGENHARIA PARA EXECUÇÃO DE REFORMA DA SALA DE ESTAR DOS DEPUTADOS DA ASSEMBLEIA LEGISLATIVA DO ESTADO DE PERNAMBUCO.',
                numeroContrato: '043/2024 (Pregão Eletrônico nº 012/2024)',
                empresa: 'SS – OBRAS DE TERRAPLENAGEM E LOCAÇÕES DE MÁQUINAS PARA CONSTRUÇÕES LTDA',
                inicio: '16/08/2024',
                prazoEstimado: '360 dias',
                conclusao: '',
                situacao: 'Concluído',
                percentual: '99.94%',
                planejadoExecutado: 'Compatível',
                planilhaOriginal: ['https://www.alepe.pe.gov.br/downloads/obras/2025-7-original.pdf'],
                planilhaAcompanhamento: [
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-7-acompanhamento.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-7-acompanhamento-2.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-7-acompanhamento-3.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-7-acompanhamento-4.pdf',
                    'https://www.alepe.pe.gov.br/downloads/obras/2025-7-acompanhamento-5.pdf'
                ]
            }
        ]
    };

    const ultimaAtualizacao = {
        '2025': '10/07/2026'
    };

    const [anoSelecionado, setAnoSelecionado] = useState('2025');
    const obras = obrasPorAno[anoSelecionado];

    const escapeCSV = (value) => {
        const str = String(value ?? '');
        if (/["\n,;]/.test(str)) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    };

    const baixarCSV = () => {
        const headers = [
            'DESCRIÇÃO', 'CONTRATO', 'EMPRESA', 'INÍCIO', 'PRAZO ESTIMADO',
            'CONCLUSÃO', 'SITUAÇÃO', 'PERCENTUAL CONCLUIDO', 'PLANEJADO X EXEC.'
        ];
        const linhas = obras.map((obra) => [
            obra.descricao,
            obra.numeroContrato,
            obra.empresa,
            obra.inicio,
            obra.prazoEstimado,
            obra.conclusao,
            obra.situacao,
            obra.percentual,
            obra.planejadoExecutado
        ].map(escapeCSV).join(','));
        const csv = [headers.map(escapeCSV).join(','), ...linhas].join('\n');
        const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `obras-${anoSelecionado}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const renderPlanilhas = (urls) => {
        if (Array.isArray(urls) && urls.length > 0) {
            return urls
                .filter((url) => url && url !== '0')
                .map((url, idx) => (
                    <span key={idx}>
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            {`${idx + 1}`}
                        </a>
                        {idx < urls.length - 1 && <br />}
                    </span>
                ));
        }
        return '';
    };

    const renderPlanilhasAcompanhamento = (urls) => {
        if (Array.isArray(urls) && urls.length > 0) {
            return urls
                .filter((url) => url && url !== '0')
                .map((url, idx) => {
                    const excelUrl = getExcelUrl(url);
                    const hasExcel = hasExcelFile(url);
                    
                    return (
                        <div key={idx} style={{ 
                            marginBottom: '4px', 
                            display: 'flex', 
                            alignItems: 'center',
                            flexWrap: 'nowrap'
                        }}>
                            <span style={{ 
                                marginRight: '8px',
                                minWidth: '20px',
                                textAlign: 'left'
                            }}>{`${idx + 1}:`}</span>
                            <a 
                                href={url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                title="Download PDF"
                                style={{ marginRight: '8px', flexShrink: 0 }}
                            >
                                <img src="/img/download-pdf.png" height="16" width="16" alt="PDF" />
                            </a>
                            {hasExcel && (
                                <a 
                                    href={excelUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    title="Download Excel"
                                    style={{ flexShrink: 0 }}
                                >
                                    <img src="/img/download-csv.png" height="16" width="16" alt="Excel" />
                                </a>
                            )}
                        </div>
                    );
                });
        }
        return '';
    };

    return (
        <div className="container py-4">
            <p>
                <small>
                    Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Obras
                </small>
            </p>
            <h1 className="mb-4">Obras</h1>

            <div className="mb-3">
                <label htmlFor="anoSelect" className="form-label">
                    Selecione o ano:
                </label>
                <select
                    id="anoSelect"
                    className="form-select"
                    value={anoSelecionado}
                    onChange={(e) => setAnoSelecionado(e.target.value)}
                >
                    {Object.keys(obrasPorAno).map((ano) => (
                        <option key={ano} value={ano}>
                            {ano}
                        </option>
                    ))}
                </select>
            </div>

            {ultimaAtualizacao[anoSelecionado] && (
                <p className="mb-3">
                    <small><strong>Última atualização:</strong> {ultimaAtualizacao[anoSelecionado]}</small>
                </p>
            )}

            <div className="d-flex justify-content-end mb-2">
                <a
                    href="#!"
                    onClick={(e) => { e.preventDefault(); baixarCSV(); }}
                    title="Download em CSV"
                >
                    <img src="/img/download-csv.png" height="16" width="16" alt="" /> CSV
                </a>
            </div>

            <div className="table-responsive">
                <table
                    className="table table-bordered table-striped table-hover align-middle table-sm small"
                >


                    <thead className="table-light">
                    <tr>
                        <th style={{ width: '200px' }}>DESCRIÇÃO</th>
                        <th style={{ width: '100px' }}>CONTRATO</th>
                        <th style={{ width: '150px' }}>EMPRESA</th>
                        <th style={{ width: '100px' }}>INÍCIO</th>
                        <th style={{ width: '100px' }}>PRAZO ESTIMADO</th>
                        <th style={{ width: '100px' }}>CONCLUSÃO</th>
                        <th style={{ width: '100px' }}>SITUAÇÃO</th>
                        <th style={{ width: '100px' }}>PERCENTUAL CONCLUIDO</th>
                        <th style={{ width: '130px' }}>PLANEJADO X EXEC.</th>
                        <th style={{ width: '120px' }}>PLAN. ORIG.</th>
                        <th style={{ width: '120px' }}>PLAN. ACOMP.</th>
                    </tr>
                    </thead>


                    <tbody>
                        {obras.map((obra, index) => (
                            <tr key={index}>
                                <td style={{ whiteSpace: 'pre-wrap' }}>{obra.descricao}</td>
                                <td>{obra.numeroContrato}</td>
                                <td>{obra.empresa}</td>
                                <td>{obra.inicio}</td>
                                <td>{obra.prazoEstimado}</td>
                                <td>{obra.conclusao}</td>
                                <td>{obra.situacao}</td>
                                <td>{obra.percentual}</td>
                                <td>{obra.planejadoExecutado}</td>
                                <td>{renderPlanilhas(obra.planilhaOriginal)}</td>
                                <td>{renderPlanilhasAcompanhamento(obra.planilhaAcompanhamento)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
